import { createConfigTabCacheKeys } from "features/shared/lib/technical-config-tab/api/cacheKeys";

const ROOT = "roomConfigTab" as const;

export const ROOM_CONFIG_CACHE_KEYS = {
  ...createConfigTabCacheKeys(ROOT),
  catalog: [ROOT, "roomCatalog"] as const,
  schedulePreset: (kind: string) => [ROOT, "schedulePreset", kind] as const,
};
